import React from 'react'
import { get } from 'lodash'

import { useRequest } from '../hooks/request'

import { CenterStuff } from './common/CenterStuff'
import { Menu } from './common/Typography'
import { Loader } from './icons/Loader'
import { PageContent } from './layout/layout'
import { useParams } from 'react-router-dom'

// This HOC performs the request its given and displays a loader meanwhile.
// it will inject getRequest for its wrapped Component to function,

export const ItemLoader = ({ request, pageTitle }) => (Component) => ({ ...rest }) => {
  const param = useParams()
  const itemId = param.id
  const getRequest = useRequest({
    request: () => request({ params: { id: itemId } }),
    start: true,
  })

  if (getRequest.state.loading || !getRequest.state.data) {
    return (
      <CenterStuff>
        <Loader height={100} />
      </CenterStuff>
    )
  }

  const finalTitle = typeof pageTitle === 'function' ? pageTitle({ item: getRequest.state.data }) : pageTitle

  return (
    <>
      {finalTitle}
      <PageContent>
        {getRequest.state.data === null
          ? <Menu tradId="itemDoesntExit" />
          : <Component getRequest={getRequest} {...rest} />}
      </PageContent>
    </>
  )
}
